// removed by extract-text-webpack-plugin
module.exports = {"button":"src-ui-button----index-module---button---1GI_-","button--size-large":"src-ui-button----index-module---button--size-large---3kp3g","button--size-default":"src-ui-button----index-module---button--size-default---2oFKG","button--theme-default":"src-ui-button----index-module---button--theme-default---1Jn6D"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/button/index.module.scss
// module id = 320
// module chunks = 168707334958949